import React from 'react'
import styled from 'styled-components'

const DesktopView = styled.div`
display: block;
@media(max-width: 700px){
    display: none;
}
`
const MobileView = styled.div`
display: none;
@media(max-width: 700px){
    display: block;
}
`

export default props => <React.Fragment>
    <DesktopView>
        {
            props.desktopComponent
        }
    </DesktopView>
    <MobileView>
        {
            props.mobileComponent
        }
    </MobileView>
</React.Fragment>


// WEBPACK FOOTER //
// ./src/_components/ResponsiveContainer/index.jsx